export const validatorMixin = {
  created () {
    this.$validator.extend('upCase', {
      getMessage: () => 'Atleast Alphabet character',
      validate: value => value.match(/[A-Za-z]/g) !== null
    })
    
  }
}

